import * as types from './types';
import * as filterTableUtils from './utils';
import { utils as leadTableUtils } from '../../leadTable/ducks';
import { utils as filterStatusUtils } from '../../filterStatus/ducks';

const crossFilterTableReducer = (state, action) => {
  switch (action.type) {
    case types.SELECTED_OPTIONS:
      state.table.leads = leadTableUtils.updateSelectedOptions(state.table.leads, action.payload);
      if (leadTableUtils.getSelectedLeads(state.table.leads).length === state.table.leads.length) {
        state.filterTable.checkedStatus = 'all';
      }
      if (leadTableUtils.getSelectedLeads(state.table.leads).length > 0) {
        state.filterTable.checkedStatus = 'single';
      } else {
        state.filterTable.checkedStatus = 'none';
      }
      return { ...state };
    case types.CHECKBOX_SELECT:
      state.filterTable.checkedStatus = action.payload;
      state.table.leads = leadTableUtils.updateSelectedOptions(state.table.leads, action.payload);
      return { ...state };
    case types.SELECTED_MULTIOPTIONS:
      state.filterTable.multiSelectOptions = filterTableUtils.updateSelectedMultiOptions(
        state.filterTable.multiSelectOptions
      )(action.payload);
      state.filterStatus.filtersSelected = filterStatusUtils.updateSelectedFilter(state.filterStatus.filtersSelected)(
        action.payload
      );
      state.table.params = { ...state.table.params, actionType: action.payload, offset: 0 };
      state.table.leads = [];
      return { ...state };
    case types.UNSELECTED_MULTIOPTIONS:
      state.filterTable.multiSelectOptions = filterTableUtils.unSelectedMultiOption(
        state.filterTable.multiSelectOptions
      )(action.payload.value);
      state.filterStatus.filtersSelected = filterStatusUtils.updateSelectedFilter(state.filterStatus.filtersSelected)(
        state.filterTable.multiSelectOptions.filter(f => f.selected)
      );
      state.table.params = {
        ...state.table.params,
        actionType: state.table.params.actionType.filter(f => f.value !== action.payload.value),
        offset: 0
      };
      state.table.leads = [];
      return { ...state };
    case types.REMOVE_ALL_FILTERS:
      state.filterStatus.filtersSelected = [];
      state.filterTable.multiSelectOptions = state.filterTable.multiSelectOptions.map(op => {
        op.selected = false;
        return op;
      });
      state.table.params = {
        ...state.table.params,
        actionType: [],
        textSearch: '',
        offset: 0
      };
      state.table.leads = [];
      return { ...state };
    case types.ADD_TEXT_SEARCH:
      if (state.filterStatus.filtersSelected.find(f => f.value === 'CustomFilter')) {
        state.filterStatus.filtersSelected.map(f => {
          if (f.value === 'CustomFilter') {
            f.label = action.payload.label;
          }
          return f;
        });
      } else {
        state.filterStatus.filtersSelected.push(action.payload);
      }
      state.table.params = { ...state.table.params, textSearch: action.payload.label, offset: 0 };
      state.table.leads = [];
      return { ...state };
    case types.REMOVE_TEXT_SEARCH:
      state.filterStatus.filtersSelected = state.filterStatus.filtersSelected.filter(f => f.value !== 'CustomFilter');
      state.table.params = { ...state.table.params, textSearch: '', offset: 0 };
      state.table.leads = [];
      return { ...state };
    case types.SORT_TABLE:
      state.filterTable.sortOptionSelected = action.payload;
      state.table.params = { ...state.table.params, sort: action.payload.value, offset: 0 };
      state.table.paramsOther = { ...state.table.paramsOther, sort: action.payload.value, offset: 0 };
      state.table.paramsPhoneCall = { ...state.table.paramsPhoneCall, sort: action.payload.value, offset: 0 };
      state.table.paramsWhatsapp = { ...state.table.paramsWhatsapp, sort: action.payload.value, offset: 0 };
      state.table.paramsEmails = { ...state.table.paramsEmails, sort: action.payload.value, offset: 0 };
      state.table.leads = [];
      return { ...state };
    default:
      return { ...state };
  }
};

export default crossFilterTableReducer;
